import React from 'react'
import { addDays, format } from 'date-fns'
import { router } from '@inertiajs/react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import FormFieldController from '../../../Components/FormFieldController'
import BackLink from '../../../Components/BackLink'
import Button from '../../../Components/Button'
import { printOrderSchema } from '../../../schemas'

const MIN_LEAD_DAYS = 10
const minDate = format(addDays(new Date(), MIN_LEAD_DAYS), 'yyyy-MM-dd')

export default function Edit({ account, accounts, navigation, print_order, print_assets, positions }) {
  const assetOptions = print_assets.map((pa) => ({
    label: `${pa.name} (${pa.size})`,
    value: pa.id
  }))

  const positionOptions = positions.map((p) => ({
    label: p.name,
    value: p.id,
    group: p.category_label
  }))

  const handleGeneratePdf = () => {
    router.post(`/manage/print_orders/${print_order.id}/generate_pdf`)
  }

  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="Edit Print Order"
    >
      <BackLink href="/manage/print_orders">Back to Print Orders</BackLink>

      {/* PDF Actions */}
      <div className="mb-6 bg-white shadow rounded-lg p-4 flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-700">
            Status: <span className="capitalize">{print_order.status_label}</span>
          </p>
          <p className="text-sm text-gray-500">
            {print_order.position_count} location{print_order.position_count !== 1 ? 's' : ''} selected
          </p>
        </div>
        <div className="flex gap-2">
          <Button onClick={handleGeneratePdf}>
            {print_order.has_pdf ? 'Regenerate PDF' : 'Generate PDF'}
          </Button>
          {print_order.has_pdf && (
            <Button href={`/manage/print_orders/${print_order.id}/download_pdf`} variant="secondary">
              Download PDF
            </Button>
          )}
        </div>
      </div>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={printOrderSchema}
          resource="print_order"
          endpoint={`/manage/print_orders/${print_order.id}`}
          method="patch"
          backLink="/manage/print_orders"
          submitLabel="Save Changes"
          defaultValues={{
            print_asset_id: print_order.print_asset_id || '',
            date: print_order.date || '',
            quantity: print_order.quantity ?? 1,
            notes: print_order.notes || '',
            position_ids: print_order.position_ids || []
          }}
        >
          {({ control, errors }) => (
            <>
              <FormFieldController
                control={control}
                name="print_asset_id"
                label="Print Asset"
                type="select"
                options={assetOptions}
                required
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="date"
                label="Desired delivery date"
                type="date"
                min={minDate}
                required
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="quantity"
                label="Quantity"
                type="number"
                hint="Number of copies per location"
                required
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="position_ids"
                label="Locations"
                type="searchableCheckboxGroup"
                options={positionOptions}
                maxItems={20}
                placeholder="Search locations..."
                emptyMessage="No locations found"
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="notes"
                label="Notes"
                type="textarea"
                rows={3}
                errors={errors}
              />
            </>
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
